import toast from 'react-hot-toast';

import { IndexRequestSchemaDataItem } from '@liscio/api';

import { RecallRequestDialog } from 'modules/requests/dialogs/RecallRequestDialog/RecallRequestDialog';
import { useRequestFilterStore } from 'modules/requests/hooks/useRequestFilterStore';

type RowMenuRecallRequestDialogProps = {
  open: boolean;
  row: IndexRequestSchemaDataItem;
  onClose: () => void;
};

export const RowMenuRecallRequestDialog = ({
  open,
  onClose,
  row,
}: RowMenuRecallRequestDialogProps) => {
  const { getRefetchRequests } = useRequestFilterStore();

  const onSuccessfulRecall = () => {
    const refetchRequests = getRefetchRequests();
    if (refetchRequests) {
      refetchRequests();
    }
    toast.success('Request recalled successfully.');
  };

  const onErroredRecall = (error: unknown) => {
    toast.error('Error recalling request.');
    console.error('Error recalling request:', error);
  };
  return (
    <RecallRequestDialog
      open={open}
      requestId={row.uuid}
      onClose={onClose}
      onSuccessfulRecall={onSuccessfulRecall}
      onErroredRecall={onErroredRecall}
    />
  );
};
